import { call, put, takeEvery } from 'redux-saga/effects';
import { getUsersQuantity } from '../../requests/get_users_quantity_request';
import {
    getUsersQuantitySuccess,
    getUsersQuantityFailure,
} from '../actions/get_users_quantity.actions';
import { GET_USERS_QUANTITY_REQUEST } from '../constants/get_users_quantity.constants';
import { message_error } from '../../../../../components/Message';

function* getUsersQuantityRequest({ groupId }) {
    const usersQuantity = yield call(getUsersQuantity, groupId);
    const { error } = usersQuantity;

    if (usersQuantity || usersQuantity === 0) {
        yield put(getUsersQuantitySuccess(usersQuantity));
    } else {
        yield put(getUsersQuantityFailure(error));
        message_error(error);
    }
}

export default function* getUsersQuantitySaga() {
    yield takeEvery(GET_USERS_QUANTITY_REQUEST, getUsersQuantityRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group/redux/sagas/get_users_quantity.saga.js